import Vue from 'vue'
import { Splide, SplideSlide } from '@splidejs/vue-splide'

import '@splidejs/splide/dist/css/splide.min.css'
Vue.component('Splide', Splide)
Vue.component('SplideSlide', SplideSlide)
